import { FC } from "react";
import { useFormContext } from "react-hook-form";
import {
  FormController,
  MuiGrid,
  MuiSelect,
  MuiSelectWithTextInput,
  OptionsDataType,
} from "../../../../components";
import { MAX_LENGTH_50 } from "../../../../helpers/constants";
import { useGridContainer } from "../../../../hooks/useGridContainer";
import { useNavigationSiteCore } from "../../../../hooks/useNavigationSiteCore";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { ProgramSearchProgramFormKey } from "../../modelsAndSchemas/models";
import { programSearchSiteCoreKeys } from "../../siteCore/SiteCoreKeys";

interface ProgramMoreFieldsProps {
  pageId: string;
  filterDropdownValue: OptionsDataType[];
  clientRelationshipOwnerMappedData: OptionsDataType[];
}

export const ProgramMoreFields: FC<ProgramMoreFieldsProps> = ({
  pageId,
  filterDropdownValue,
  clientRelationshipOwnerMappedData,
}) => {
  const { gridSizeLarge: gridSize, gridSizeLargeClass } = useGridContainer();
  const { control } = useFormContext();
  const { commonLabels, useFetchLabel, commonValidationMessages } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();

  const getLabel = useFetchLabel(programSearchSiteCoreKeys.searchFormKey);
  return (
    <MuiGrid container className="form-container">
      <MuiGrid size={gridSize} className={gridSizeLargeClass}>
        <FormController
          control={control}
          name={ProgramSearchProgramFormKey.projectKey}
        >
          <MuiSelectWithTextInput
            options={filterDropdownValue}
            label={getLabel(programSearchSiteCoreKeys.projectKey)}
            placeholder={commonLabels.inputPlaceHolder}
            control={control}
            selectBoxName={ProgramSearchProgramFormKey.projectKeyFilter}
            id={`${pageId}-${ProgramSearchProgramFormKey.projectKey}`}
            selectBoxId={`${pageId}-${ProgramSearchProgramFormKey.projectKeyFilter}`}
            maxLength={MAX_LENGTH_50}
            requiredARIALabel={commonARIALabel.required}
          />
        </FormController>
      </MuiGrid>

      <MuiGrid size={gridSize} className={gridSizeLargeClass}>
        <FormController
          control={control}
          name={ProgramSearchProgramFormKey.projectName}
        >
          <MuiSelectWithTextInput
            options={filterDropdownValue}
            label={getLabel(programSearchSiteCoreKeys.projectName)}
            placeholder={commonLabels.inputPlaceHolder}
            control={control}
            selectBoxName={ProgramSearchProgramFormKey.projectNameFilter}
            id={`${pageId}-${ProgramSearchProgramFormKey.projectName}`}
            selectBoxId={`${pageId}-${ProgramSearchProgramFormKey.projectNameFilter}`}
            maxLength={MAX_LENGTH_50}
            requiredARIALabel={commonARIALabel.required}
            tooltipMessage={
              commonValidationMessages.fieldSpecialCharactersTooltipMessage
            }
            tooltipHeaderTitle={
              commonValidationMessages.allowedSpecialCharactersTitle
            }
          />
        </FormController>
      </MuiGrid>

      <MuiGrid size={gridSize} className={gridSizeLargeClass}>
        <FormController
          control={control}
          name={ProgramSearchProgramFormKey.billingContactLastName}
        >
          <MuiSelectWithTextInput
            selectBoxId={`${pageId}-${ProgramSearchProgramFormKey.billingContactLastNameFilter}`}
            label={getLabel(
              programSearchSiteCoreKeys.billingContactLastNameLabel,
            )}
            options={filterDropdownValue}
            placeholder={commonLabels.inputPlaceHolder}
            id={`${pageId}-${ProgramSearchProgramFormKey.billingContactLastName}`}
            control={control}
            selectBoxName={
              ProgramSearchProgramFormKey.billingContactLastNameFilter
            }
            maxLength={MAX_LENGTH_50}
            requiredARIALabel={commonARIALabel.required}
            tooltipMessage={
              commonValidationMessages.fieldSpecialCharactersTooltipMessage
            }
            tooltipHeaderTitle={
              commonValidationMessages.allowedSpecialCharactersTitle
            }
          />
        </FormController>
      </MuiGrid>
      <MuiGrid size={gridSize} className={gridSizeLargeClass}>
        <FormController
          control={control}
          name={ProgramSearchProgramFormKey.hrContactLastName}
        >
          <MuiSelectWithTextInput
            control={control}
            id={`${pageId}-${ProgramSearchProgramFormKey.hrContactLastName}`}
            options={filterDropdownValue}
            label={getLabel(programSearchSiteCoreKeys.hRContactLastNameLabel)}
            selectBoxName={ProgramSearchProgramFormKey.hrContactLastNameFilter}
            selectBoxId={`${pageId}-${ProgramSearchProgramFormKey.hrContactLastNameFilter}`}
            placeholder={commonLabels.inputPlaceHolder}
            requiredARIALabel={commonARIALabel.required}
            maxLength={MAX_LENGTH_50}
            tooltipMessage={
              commonValidationMessages.fieldSpecialCharactersTooltipMessage
            }
            tooltipHeaderTitle={
              commonValidationMessages.allowedSpecialCharactersTitle
            }
          />
        </FormController>
      </MuiGrid>

      <MuiGrid size={gridSize} className={gridSizeLargeClass}>
        <FormController
          control={control}
          name={ProgramSearchProgramFormKey.clientRelationshipOwner}
        >
          <MuiSelect
            id={`${pageId}-${ProgramSearchProgramFormKey.clientRelationshipOwner}`}
            options={clientRelationshipOwnerMappedData}
            label={getLabel(
              programSearchSiteCoreKeys.localClientRelationshipOwner,
            )}
            value=""
            requiredARIALabel={commonARIALabel.required}
            placeholder={commonLabels.selectPlaceHolder}
            visibleDefaultSelectOption
            showSearch
          />
        </FormController>
      </MuiGrid>
    </MuiGrid>
  );
};
